"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function SalesforceGreyMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M15.598 7.186a3.457 3.457 0 01-3.457 3.457c-.241 0-.483-.04-.724-.08-.482.683-1.246 1.125-2.13 1.125-.322 0-.603-.04-.845-.16a2.583 2.583 0 01-2.331 1.487c-1.126 0-2.09-.724-2.453-1.769-.2.04-.361.08-.562.08A2.694 2.694 0 01.402 8.634c0-.924.483-1.769 1.206-2.251a3.427 3.427 0 01-.12-.925c-.08-1.688 1.286-3.055 3.015-3.055.964 0 1.809.442 2.371 1.085a2.58 2.58 0 011.85-.763c.924 0 1.769.482 2.21 1.246.403-.161.805-.241 1.247-.241 1.89.04 3.417 1.567 3.417 3.457z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    d: "M10.613 3.608l-6.995 7.678c-.16.04-.362.04-.563.04A2.694 2.694 0 01.362 8.634c0-.924.482-1.769 1.206-2.251a3.426 3.426 0 01-.12-.925C1.406 3.77 2.773 2.402 4.502 2.402c.964 0 1.809.442 2.371 1.085a2.58 2.58 0 011.85-.763c.723 0 1.407.361 1.89.884z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M6.11 13.417a2.968 2.968 0 01-2.693-1.729h-.322A3.097 3.097 0 010 8.593c0-.925.402-1.81 1.126-2.412a1.878 1.878 0 01-.121-.684A3.5 3.5 0 014.503 2c.884 0 1.728.322 2.371.965a2.968 2.968 0 011.81-.603c.964 0 1.809.442 2.371 1.166.362-.121.724-.161 1.086-.161a3.86 3.86 0 010 7.718c-.201 0-.362 0-.563-.04a2.979 2.979 0 01-2.292 1.086c-.24 0-.442-.04-.683-.08-.523.844-1.487 1.366-2.492 1.366zM3.9 10.804l.12.322c.322.884 1.126 1.487 2.09 1.487.845 0 1.609-.482 1.97-1.246l.161-.322.322.12c.241.081.482.121.723.121.724 0 1.408-.361 1.81-.924l.16-.201.282.04c.2.04.402.08.643.08a3.054 3.054 0 003.055-3.055 3.054 3.054 0 00-3.055-3.055c-.362 0-.724.08-1.085.2l-.322.121-.16-.28a2.194 2.194 0 00-1.89-1.046c-.603 0-1.126.241-1.568.643l-.322.322-.281-.322c-.523-.643-1.287-1.005-2.05-1.005A2.694 2.694 0 001.93 6.302l.08.28-.241.162C1.126 7.146.764 7.869.764 8.634a2.29 2.29 0 002.291 2.29c.161 0 .322 0 .483-.04l.362-.08z"
  }));
}

SalesforceGreyMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
SalesforceGreyMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = SalesforceGreyMultitoneFilled;
exports["default"] = _default;